import { useBuskingStore } from './useBuskingStore';

export const useBuskingPayload = () => {
  const { get } = useBuskingStore();
  const can_be_contacted =
    get('receiveConfirmationEmail').toLowerCase() == 'yes' ? true : false;
  const can_back_office_contact =
    get('contactUserOption').toLowerCase() == 'yes' ? true : false;

  const happening_now =
    get('isIssueHappeningNow').toLowerCase() == 'yes' ? true : false;

  const dateTime = get('dateTime') || new Date();

  const payload = {
    ChannelObject: {
      channel: 'Online',
      platform: 'React',
      session_id: get('sessionId'),
    },
    ServiceLocationObject: {
      address_line_1: get('issueLocationData.address_line_1'),
      address_line_2: get('issueLocationData.address_line_2'),
      town_city: get('issueLocationData.town'),
      county: get('issueLocationData.county'),
      postcode: get('issueLocationData.postcode'),
      country: get('issueLocationData.country'),
      UPRN: get('issueLocationData.UPRN'),
      USRN: get('issueLocationData.USRN'),
      latitude: Number(get('issueLocationData.latitude')),
      longitude: Number(get('issueLocationData.longitude')),
      easting: get('issueLocationData.easting'),
      northing: get('issueLocationData.northing'),
      additional_details: '',
      is_commercial: get('issueLocationData.is_commercial'),
      is_within_borough: get('issueLocationData.is_within_borough'),
    },
    ReporterObject: {
      can_back_office_contact,
      can_be_contacted,
      contact_id: null,
      ...(can_be_contacted || can_back_office_contact
        ? {
            name: {
              first_name: get('firstName'),
              last_name: get('lastName'),
            },
            contact_details: {
              email_address: get('email'),
              ...(can_back_office_contact
                ? { phone_number: get('phoneNumber') }
                : {}),
            },
          }
        : {}),
    },
    ReportObject: {
      categories: get('issueTypes').map((type) => type.name),
      happening_now,
      time: new Date(dateTime),
      issue_description: get('describeTheIssue'),
      performer_description: get('describeThePerformer'),
      pitch_uprn: get('issueLocationData.asset.UPRN' as any) ?? '',
    },
    ...(get('uploadedImagesBlob').length > 0 && {
      FileCollectionObject: {
        external: true,
        files: get('uploadedImagesBlob').map((imageblob) => ({
          path: imageblob.blob_uri,
          name: imageblob.filename,
        })),
      },
    }),
  };

  return payload;
};
